// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__joizC","large":"styles_large__1Isch"};